module.exports = __webpack_public_path__ + "static/media/ic-audio.196ec785.svg";